import axiosInstance from "../utils/axios";

export const customerPortal = async (data) => {
  try {
    const res = await axiosInstance.post("/stripe/customer/portal", data, {
      withCredentials: true,
    });
    window.location.href = res.data;
    return { redirect: "ok" };
  } catch (e) {
    console.error(e);
    return e;
  }
};

export const customerPortalInfo = async (data) => {
  try {
    const res = await axiosInstance.post("/stripe/customer/portal/info", data, {
      withCredentials: true,
    });
    window.location.href = res.data;
    return { redirect: "ok" };
  } catch (e) {
    console.error(e);
    return e;
  }
};
